const Greedy = [
    {
      Topic: "Greedy",
      Problem: "Activity Selection Problem",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/activity-selection-1587115620/1/",
      URL2: "https://www.codingninjas.com/codestudio/problems/maximum-activities_1062712?topList=love-babbar-dsa-sheet-problems",
      Id: 1
    },
    {
      Topic: "Greedy",
      Problem: "Job Sequencing Problem",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/job-sequencing-problem/0",
      URL2: "https://www.codingninjas.com/codestudio/problems/job-sequencing-problem_1169460?topList=love-babbar-dsa-sheet-problems",
      Id: 2
    },
    {
      Topic: "Greedy",
      Problem: "Huffman Coding",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/huffman-encoding/0",
      URL2: "https://www.codingninjas.com/codestudio/problems/huffman-coding_1169467?topList=love-babbar-dsa-sheet-problems",
      Id: 3
    },
    {
      Topic: "Greedy",
      Problem: "Water Connection Problem",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/water-connection-problem/0",
      URL2: "https://www.codingninjas.com/codestudio/problems/minimum-weight-in-a-connected-component_1170508?topList=love-babbar-dsa-sheet-problems",
      Id: 4
    },
    {
      Topic: "Greedy",
      Problem: "Fractional Knapsack Problem",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/fractional-knapsack/0",
      URL2: "https://www.codingninjas.com/codestudio/problems/fractional-knapsack_975286?topList=love-babbar-dsa-sheet-problems",
      Id: 5
    },
    {
      Topic: "Greedy",
      Problem: "Greedy Algorithm to find Minimum number of Coins",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/coin-piles/0",
      URL2: "https://www.codingninjas.com/codestudio/problems/greedy-algorithm-for-ninja-and-the-coins_3191489?topList=love-babbar-dsa-sheet-problems",
      Id: 6
    },
    {
      Topic: "Greedy",
      Problem: "Maximum trains for which stoppage can be provided",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.geeksforgeeks.org/maximum-trains-stoppage-can-provided/",
      URL2: "https://www.codingninjas.com/codestudio/problems/maximum-trains-for-which-stoppage-can-be-provided_1169456?topList=love-babbar-dsa-sheet-problems",
      Id: 7
    },
    {
      Topic: "Greedy",
      Problem: "Minimum Platforms Problem",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/minimum-platforms/0",
      URL2: "https://www.codingninjas.com/codestudio/problems/minimum-number-of-platforms_799400?topList=love-babbar-dsa-sheet-problems",
      Id: 8
    },
    {
      Topic: "Greedy",
      Problem: "Buy Maximum Stocks if i stocks can be bought on i-th day",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.geeksforgeeks.org/buy-maximum-stocks-stocks-can-bought-th-day/",
      URL2: "https://www.codingninjas.com/codestudio/problems/maximum-shares_3114365?topList=love-babbar-dsa-sheet-problems",
      Id: 9
    },
    {
      Topic: "Greedy",
      Problem: "Find the minimum and maximum amount to buy all N candies",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/shop-in-candy-store/0",
      URL2: "https://www.codingninjas.com/codestudio/problems/minimum-and-maximum-cost-to-buy-n-candies_975298?topList=love-babbar-dsa-sheet-problems",
      Id: 10
    },
    {
      Topic: "Greedy",
      Problem: "Minimize Cash Flow among a given set of friends who have borrowed money from each other",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.geeksforgeeks.org/minimize-cash-flow-among-given-set-friends-borrowed-money/",
      URL2: "https://www.codingninjas.com/codestudio/problems/minimize-cash-flow-among-a-given-set-of-friends-who-have-borrowed-money-from-each-other_1170048?topList=love-babbar-dsa-sheet-problems",
      Id: 11
    },
    {
      Topic: "Greedy",
      Problem: "Minimum Cost to cut a board into squares",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.geeksforgeeks.org/minimum-cost-cut-board-squares/",
      URL2: "https://www.codingninjas.com/codestudio/problems/board-cutting_975500?topList=love-babbar-dsa-sheet-problems",
      Id: 12
    },
    {
      Topic: "Greedy",
      Problem: "Check if it is possible to survive on Island",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.geeksforgeeks.org/survival/",
      URL2: "https://www.codingninjas.com/codestudio/problems/check-if-possible-to-survive_1170052?topList=love-babbar-dsa-sheet-problems",
      Id: 13
    },
    {
      Topic: "Greedy",
      Problem: "Find maximum meetings in one room",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.geeksforgeeks.org/find-maximum-meetings-in-one-room/",
      URL2: "https://www.codingninjas.com/codestudio/problems/maximum-meetings_1062658?topList=love-babbar-dsa-sheet-problems",
      Id: 14
    },
    {
      Topic: "Greedy",
      Problem: "Maximum product subset of an array",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.geeksforgeeks.org/maximum-product-subset-array/",
      URL2: "https://www.codingninjas.com/codestudio/problems/max-product-subset_1170054?topList=love-babbar-dsa-sheet-problems",
      Id: 15
    },
    {
      Topic: "Greedy",
      Problem: "Maximize array sum after K negations",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/maximize-sum-after-k-negations/0",
      URL2: "https://www.codingninjas.com/codestudio/problems/max-sum-after-k-negations_1170050?topList=love-babbar-dsa-sheet-problems",
      Id: 16
    },
    {
      Topic: "Greedy",
      Problem: "Maximize the sum of arr[i]*i",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/maximize-arrii-of-an-array/0",
      URL2: "https://www.codingninjas.com/codestudio/problems/maximum-sum_2824971?topList=love-babbar-dsa-sheet-problems",
      Id: 17
    },
    {
      Topic: "Greedy",
      Problem: "Maximum sum of absolute difference of an array",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.geeksforgeeks.org/maximum-sum-absolute-difference-array/",
      URL2: "https://www.codingninjas.com/codestudio/problems/maximum-sum-of-absolute-difference_1164175?topList=love-babbar-dsa-sheet-problems",
      Id: 18
    },
    {
      Topic: "Greedy",
      Problem: "Maximize sum of consecutive differences in a circular array",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/swap-and-maximize/0",
      URL2: "https://www.codingninjas.com/codestudio/problems/swap-and-maximise_1164405?topList=love-babbar-dsa-sheet-problems",
      Id: 19
    },
    {
      Topic: "Greedy",
      Problem: "Minimum sum of absolute difference of pairs of two arrays",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.geeksforgeeks.org/minimum-sum-absolute-difference-pairs-two-arrays/",
      URL2: "https://www.codingninjas.com/codestudio/problems/minimum-difference_1164402?topList=love-babbar-dsa-sheet-problems",
      Id: 20
    },
    {
      Topic: "Greedy",
      Problem: "Program for Shortest Job First (or SJF) CPU Scheduling",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.geeksforgeeks.org/program-for-shortest-job-first-or-sjf-cpu-scheduling-set-1-non-preemptive/",
      URL2: "https://www.codingninjas.com/codestudio/problems/sjf_1172165?topList=love-babbar-dsa-sheet-problems",
      Id: 21
    },
    {
      Topic: "Greedy",
      Problem: "Program for Least Recently Used (LRU) Page Replacement algorithm",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/page-faults-in-lru/0",
      URL2: "https://www.codingninjas.com/codestudio/problems/page-faults_2826682?topList=love-babbar-dsa-sheet-problems",
      Id: 22
    },
    {
      Topic: "Greedy",
      Problem: "Smallest subset with sum greater than all other elements",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.geeksforgeeks.org/smallest-subset-sum-greater-elements/",
      URL2: "https://www.codingninjas.com/codestudio/problems/find-the-smallest-subset-of-balls-whose-weight-is-greater-than-the-weight-of-remaining-balls_1170530?topList=love-babbar-dsa-sheet-problems",
      Id: 23
    },
    {
      Topic: "Greedy",
      Problem: "Chocolate Distribution Problem",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/chocolate-distribution-problem/0",
      URL2: "",
      Id: 24
    },
    {
      Topic: "Greedy",
      Problem: "DEFKIN -Defense of a Kingdom",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.spoj.com/problems/DEFKIN/",
      URL2: "",
      Id: 25
    },
    {
      Topic: "Greedy",
      Problem: "DIEHARD -DIE HARD",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.spoj.com/problems/DIEHARD/",
      URL2: "",
      Id: 26
    },
    {
      Topic: "Greedy",
      Problem: "GERGOVIA -Wine trading in Gergovia",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.spoj.com/problems/GERGOVIA/",
      URL2: "",
      Id: 27
    },
    {
      Topic: "Greedy",
      Problem: "Picking Up Chicks",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.spoj.com/problems/GCJ101BB/",
      URL2: "",
      Id: 28
    },
    {
      Topic: "Greedy",
      Problem: "CHOCOLA –Chocolate",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.spoj.com/problems/CHOCOLA/",
      URL2: "",
      Id: 29
    },
    {
      Topic: "Greedy",
      Problem: "ARRANGE -Arranging Amplifiers",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.spoj.com/problems/ARRANGE/",
      URL2: "",
      Id: 30
    },
    {
      Topic: "Greedy",
      Problem: "K Centers Problem",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.geeksforgeeks.org/k-centers-problem-set-1-greedy-approximate-algorithm/",
      URL2: "https://www.codingninjas.com/codestudio/problems/k-centers_1280117?topList=love-babbar-dsa-sheet-problems",
      Id: 31
    },
    {
      Topic: "Greedy",
      Problem: "Minimum Cost of ropes",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/minimum-cost-of-ropes/0",
      URL2: "https://www.codingninjas.com/codestudio/problems/connect-n-ropes-with-minimum-cost_630476?topList=love-babbar-dsa-sheet-problems",
      Id: 32
    },
    {
      Topic: "Greedy",
      Problem: "Find smallest number with given number of digits and sum of digits",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/smallest-number5829/1",
      URL2: "https://www.codingninjas.com/codestudio/problems/smallest-number_1164401?topList=love-babbar-dsa-sheet-problems",
      Id: 33
    },
    {
      Topic: "Greedy",
      Problem: "Rearrange characters in a string such that no two adjacent are same",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://practice.geeksforgeeks.org/problems/rearrange-characters4649/1",
      URL2: "",
      Id: 34
    },
    {
      Topic: "Greedy",
      Problem: "Find maximum sum possible equal sum of three stacks",
      Done: false,
      Bookmark: false,
      Notes: "",
      URL: "https://www.geeksforgeeks.org/find-maximum-sum-possible-equal-sum-three-stacks/",
      URL2: "https://www.codingninjas.com/codestudio/problems/maximum-equal-sum-stack_1164270?topList=love-babbar-dsa-sheet-problems",
      Id: 35
    }
  ];

export default Greedy;